import { ExpandableCheckbox } from 'modules/workflowNodeEditors/editorComponents';
import { Link } from 'ui/links';
import noop from 'utils/noop';

export interface IgnoreFrequencyCapCheckboxProps {
  ignoreFrequencyCap?: boolean;
  onChange?: (ignoreFrequencyCap: boolean) => void;
  isDisabled?: boolean;
  tooltipContent?: string;
}

export const IGNORE_FREQUENCY_CAP_TEXT = {
  captionText: 'Send this message regardless of any frequency caps.',
  id: 'ignore-frequency-cap',
  label: 'Ignore frequency cap',
  supportUrl: 'https://support.iterable.com/hc/articles/7412316462996',
  testId: 'ignore-frequency-cap-test-id',
};

export const IgnoreFrequencyCapCheckbox = ({
  ignoreFrequencyCap,
  onChange = noop,
  isDisabled = false,
  tooltipContent,
}: IgnoreFrequencyCapCheckboxProps) => {
  const handleChange = () => {
    onChange(!ignoreFrequencyCap);
  };

  return (
    <ExpandableCheckbox
      caption={
        <>
          {IGNORE_FREQUENCY_CAP_TEXT.captionText}
          &nbsp;
          <Link size="caption" href={IGNORE_FREQUENCY_CAP_TEXT.supportUrl}>
            Learn more
          </Link>
        </>
      }
      data-test={IGNORE_FREQUENCY_CAP_TEXT.testId}
      id={IGNORE_FREQUENCY_CAP_TEXT.id}
      isChecked={Boolean(ignoreFrequencyCap)}
      isDisabled={isDisabled}
      label={IGNORE_FREQUENCY_CAP_TEXT.label}
      onEnabledUpdate={handleChange}
      hasTooltip={!!tooltipContent}
      tooltipContent={tooltipContent}
    />
  );
};
